module.exports = __webpack_public_path__ + "static/media/img15.4c0a3031.jpg";